import i18n from '@/plugins/vue-i18n'

export default [
  {
    path: '/calendar',
    name: 'calendar',
    component: () => import('./pages/Calendar.vue'),
    meta: {
      authenticatedOnly: true,
      breadcrumb: [
        {
          text: i18n.t('navigation.calendar'),
          to: {
            name: 'calendar'
          }
        }
      ]
    }
  }
]
